export enum SectionDashboardTheme {
    Light = 'light',
    Dark = 'dark',
}
